import makeInvokeBackendFunction from './makeInvokeBackendFunction.js';

export default function authenticate(app) {
  const req = { domainName: 'account.octopus-esm.com' };

  return async (username, password) => {
    const invokeFunction = makeInvokeBackendFunction(req);
    const result = await invokeFunction(
      'authenticate',
      { username, password, appId: app.id },
      'POST'
    );

    return result.data;
  };
}
